import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 200
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
});

class Error extends Component {
  constructor() {
    super();
    this.state = {

    };

  }

  render() {
    const { classes } = this.props;

    return (
      <Container maxWidth="lg" className={classes.container}>
        <Grid item xs={12} container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
          style={{ minHeight: '50vh' }}>
          {/* <Paper className={classes.paper}> */}

          <Typography variant="h1" component="h2" gutterBottom align="left">
            Ooops! 
          </Typography>
          <Typography variant="h3" component="h3" gutterBottom>
            Something Went wrong.
          </Typography>
          <div className={classes.root}>
          <Button  color="secondary">Report</Button>
          <Button  color="primary">Back Home</Button>
          </div>

          {/* </Paper> */}
        </Grid>

      </Container>

    );
  }
}

export default withStyles(useStyles)(Error);
